import { createNamespacer, createReducer } from "../utils/reducers";

const initialState = {
  editMode: false,
};

const namespacer = createNamespacer("DASHBOARD");

const handlers = {
  [namespacer("SET_EDIT_MODE")]: (state: any, action: any) => {
    return {
      ...state,
      editMode: action.payload.editMode,
    };
  },
};

const reducer = createReducer(initialState, handlers, ["DASHBOARD"]);

export default reducer;
